import type {
  CurriculumSourceStatus,
  PublicLesson,
} from "./contracts";

export const DEMO_DISCLOSURE_TITLE = "界面演示数据";
export const DEMO_DISCLOSURE_DETAIL =
  "不是发布教材，不产生正式学习证据";
export const DEMO_SOURCE_ID_PREFIX = "demo-ui-only:";
export const DEMO_PLACEHOLDER_SHA256 = "0".repeat(64);
export const NON_RELEASE_SOURCE_DRAFT_REASON =
  "NON_RELEASE source-aligned draft fixture; canonical dual review is not granted";

export function lessonPassesClientPublicationGate(
  lesson: PublicLesson,
): boolean {
  return (
    lesson.approvalStatus === "approved" &&
    lesson.sourceStatus.kind === "approved"
  );
}

export function assertClientPublishableLesson(lesson: PublicLesson): void {
  if (!lessonPassesClientPublicationGate(lesson)) {
    throw new Error("课程教材尚未完成发布审核，不能进入正式课堂。");
  }
}

export function lessonPassesNonReleaseSourceDraftGate(
  lesson: PublicLesson,
): boolean {
  return (
    lesson.approvalStatus === "draft" &&
    lesson.sourceStatus.kind === "source_draft"
  );
}

export function assertClientClassroomLesson(
  lesson: PublicLesson,
  options: { allowNonReleaseSourceDrafts: boolean },
): void {
  if (lessonPassesClientPublicationGate(lesson)) return;
  if (
    options.allowNonReleaseSourceDrafts &&
    lessonPassesNonReleaseSourceDraftGate(lesson)
  ) {
    return;
  }
  throw new Error("课程教材尚未完成发布审核，不能进入正式课堂。");
}

export function curriculumSourceStatus(
  lesson: PublicLesson,
): CurriculumSourceStatus {
  return lesson.sourceStatus;
}
